import React from 'react'
import { DatePicker } from 'cantarus-react-ui'
import { FieldDataStrings as Strings } from '../../../utils/config'
import { toMoment } from '../../../utils/helpers'

const FieldDataDateTime = ({ fieldName, fieldValue, handleFieldDataTextChange, showTimeInput }) => {

    const onDataChange = (data) => {
        handleFieldDataTextChange(fieldName, data);
    }

    return (
        <DatePicker
            label={Strings.header}
            onChange={onDataChange}
            date={toMoment(fieldValue)}
            placeholder={Strings.placeholder}
            showTimeInput={showTimeInput}
        />
    );
}

export default FieldDataDateTime;
